import ContentDivider from './content-divider';
export default ContentDivider;
export { ContentDivider};
